import { render, staticRenderFns } from "./certificate-print2.vue?vue&type=template&id=413c750c&scoped=true"
import script from "./certificate-print2.vue?vue&type=script&lang=js"
export * from "./certificate-print2.vue?vue&type=script&lang=js"
import style0 from "./certificate-print2.vue?vue&type=style&index=0&id=413c750c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413c750c",
  null
  
)

export default component.exports